/**
 * External Dependencies
 */
import 'jquery';
import Alpine from 'alpinejs';
import Flickity from 'flickity-fade';
import 'lity';

import { debounce } from 'underscore';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import collapse from '@alpinejs/collapse'
 
Alpine.plugin(collapse)
window.Alpine = Alpine
Alpine.start()

$(() => {

    gsap.config({
        nullTargetWarn: false,
      });

    if ($('.believe-carousel').is(':visible')) {
        var bCarousel = new Flickity('.believe-carousel', {
            // options
            freeScroll: true,
            wrapAround: true,
            arrowShape: 'M99,50a6.1,6.1,0,0,1-6.1,6.1h-71L48.2,82.4A6.2,6.2,0,0,1,50,86.8a6.1,6.1,0,0,1-6.1,6.1,6,6,0,0,1-4.4-1.8L2.8,54.3a4.8,4.8,0,0,1-1.4-2,6.8,6.8,0,0,1,0-4.6,4.8,4.8,0,0,1,1.4-2L39.5,8.9a6,6,0,0,1,4.4-1.8,5.8,5.8,0,0,1,4.3,1.8A5.8,5.8,0,0,1,50,13.2a6.2,6.2,0,0,1-1.8,4.4L21.9,43.9h71A6.1,6.1,0,0,1,99,50Z'
        });
    }

    if ($('.believe-carousel-2').is(':visible')) {
        var bCarousel2 = new Flickity('.believe-carousel-2', {
            // options
            freeScroll: true,
            wrapAround: true,
            arrowShape: 'M99,50a6.1,6.1,0,0,1-6.1,6.1h-71L48.2,82.4A6.2,6.2,0,0,1,50,86.8a6.1,6.1,0,0,1-6.1,6.1,6,6,0,0,1-4.4-1.8L2.8,54.3a4.8,4.8,0,0,1-1.4-2,6.8,6.8,0,0,1,0-4.6,4.8,4.8,0,0,1,1.4-2L39.5,8.9a6,6,0,0,1,4.4-1.8,5.8,5.8,0,0,1,4.3,1.8A5.8,5.8,0,0,1,50,13.2a6.2,6.2,0,0,1-1.8,4.4L21.9,43.9h71A6.1,6.1,0,0,1,99,50Z'

        });
    }

    if ($('.faq-carousel').is(':visible')) {
        var faqCarousel = new Flickity('.faq-carousel', {
            freeScroll: true,
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            watchCSS: true,
            
        })
    }

    if ($('.block-carousel').is(':visible')) {
        var carousel = new Flickity('.block-carousel', {
            prevNextButtons: true,
            pageDots: false,
        })
    }

    if ($('.update-carousel').is(':visible')) {
        var updateCarousel = new Flickity('.update-carousel', {
            prevNextButtons: false,
            pageDots: false,
            fade: true,
            autoPlay: true,
            pauseAutoPlayOnHover: false,
        })

        var $carousel = $('.update-carousel');

        $carousel.on( 'change.flickity', function( event, index ) {
            //console.log( 'Slide changed to ' + index )
            $('.update-nav').children().removeClass('active');
            $('.update-nav').find(`[data-index='${index}']`).addClass('active');
        });

        $('.update-nav').on( 'click', '.button', function() {
            var index = $(this).index();
            updateCarousel.select( index);
            updateCarousel.stopPlayer();
          });
    }

    const navLinks = gsap.utils.toArray(".faq-carousel .faq-nav");

    navLinks.forEach((link, i) => {
        link.addEventListener("click", function(e) {
        
            var href = e.currentTarget.getAttribute("href")
            var anchor = href.substring(href.indexOf("#"))
        
            if(document.querySelectorAll(anchor).length > 0) {
            e.preventDefault();
            gsap.to(window, {duration: 1, scrollTo: {y: anchor, offsetY: 100 }});
            }
        });
    });

    gsap.utils.toArray(".faq-item").forEach((box, i) => {
        var id = box.getAttribute("id");
        gsap.to(box, {
            scrollTrigger: {
            trigger: box,
            start: "top 25%",
            end: "bottom 25%",
            //markers: true,
            toggleClass: {targets: ".faq-carousel a[href='#" + id + "']", className: "active"},
            onEnter: function(box) {
                var index = $(".faq-items #" + id).data('index');
                faqCarousel.select( index);
                //console.log(index);
            },
            onEnterBack: function() {
                var index = $(".faq-items #" + id).data('index');
                faqCarousel.select( index);
                //console.log(index);
            }
            },
        });
    });

    $('.faq-items .faq-title').on('click', function() {
        ScrollTrigger.refresh(true);
    })

    $('.tag-filters .filters').on(
        'change',
        'input[type="checkbox"]',
        debounce(tagFilters, 1500)
      );

      $('.remove-container button').on('click', function() {
        var value = $(this).data('value');
        $('.tag-filters input[type="checkbox"][value="' + value + '"]').attr("checked",false);
        tagFilters();
        //console.log(value)
      })

      $('.date-container button').on('click', function() {

        var curr = window.location.href;
        var urlParts = curr.split('?');
        var params = new URLSearchParams(urlParts[1]);

        params.delete('start_date');
        params.delete('end_date');

        var newUrl = urlParts[0] + '?' + params.toString();

        var newSep = newUrl.split('?');

        console.log(newSep);

        if (newSep[1] !== '') {
    
            var newUrl = newSep[0] + '?' + params.toString();
        }
        else {
            var newUrl = newSep[0];
        }

        window.location.replace(newUrl);

       //console.log(newUrl);


        //console.log(value)
      })
    
      function tagFilters() {
        var url = location.protocol + '//' + location.host + location.pathname,
          args = {};
        
        var curr = window.location.href;
        var parseUrl = new URL(curr);
        var start = parseUrl.searchParams.get("start_date");
        var end = parseUrl.searchParams.get("end_date");

        url = url.split('page/')[0];
    
        // loop over filters
        $('.tag-filters .filters').each(function () {
          // vars
          var filter = $(this).data('filter');
          var vals = [];
    
          //console.log(filter)
    
          // find checked inputs
          $(this)
            .find('input:checked')
            .each(function () {
              //console.log($(this).val())
              vals.push($(this).val());
            });
    
          //console.log(vals)
    
          // append to args
          args[filter] = vals.join(',');
          //console.log(args)
        });
    
        // update url
        url += '?';
    
        // loop over args
        $.each(args, function (name, value) {
          if (value) {
            url += name + '=' + value + '&';
          }
        });

        if(start) {
            url += 'start_date=' + start + '&';
        }
        if(end) {
            url += 'end_date=' + end + '&';
        }
    
        // remove last &
        url = url.slice(0, -1);
    
        //console.log(url)
        // reload page
        window.location.replace(url);
      }

      var heroBoxes = gsap.utils.toArray(".hero-links-container .hero-item");
      gsap.from(heroBoxes, {
        opacity: 0,
        yPercent: 2,
        duration: 1.3, 
        stagger: .3,
        scrollTrigger: {
            trigger: '.wp-block-home-hero',
            start: "top 50%",
            //markers: true,
          },
      });

      var factBoxes = gsap.utils.toArray(".facts-container .fact-item .fact-figure");
      gsap.from(factBoxes, {
        opacity: 0,
        yPercent: 2,
        duration: 1.3, 
        stagger: .2,
        scrollTrigger: {
            trigger: '.wp-block-quick-facts',
            start: "top 50%",
            //markers: true,
          },
      });

      gsap.from('.wp-block-believe .content-container', {
        opacity: 0,
        yPercent: 4,
        duration: 1, 
        scrollTrigger: {
            trigger: '.wp-block-believe ',
            start: "top 50%",
            //markers: true,
          },
      })

      // Mouseenter function
    function enterAnimation(link, e, index) {
      link.tl.tweenFromTo(0, "midway");
    }

    // Mouseleave function
    function leaveAnimation(link, e) {
      link.tl.play();
    }

    // Animations variables
    let workLinkUnderlineAnimEnter;
    let workLinkUnderlineAnimLeave;

    // Get all links
    let workLinks = document.querySelectorAll(".underline-anim");

    workLinks.forEach((link, index, value) => {
      
      let underline = link.querySelector(".border-anim");
      link.tl = gsap.timeline({paused: true});
      
      link.tl.fromTo(underline, {
        width: "0%",
        left: "0%",
      }, {
        width: "100%",
        duration: 0.4, 
      });
      
      link.tl.add("midway");
      
      link.tl.fromTo(underline, {
        width: "100%",
        left: "0%",
      }, {
        width: "0%",
        left: "100%",
        duration: 0.4, 
        immediateRender: false
      });
      
      // Mouseenter
      link.addEventListener("mouseenter", (e) => {
        enterAnimation(link, e, index);
      });

      // Mouseleave
      link.addEventListener("mouseleave", (e) => {
        leaveAnimation(link, e);
      });

    });


});

Flickity.prototype._createResizeClass = function() {
    this.element.classList.add('flickity-resize');
  };
  
  Flickity.createMethods.push('_createResizeClass');
  
  var resize = Flickity.prototype.resize;
  Flickity.prototype.resize = function() {
    this.element.classList.remove('flickity-resize');
    resize.call( this );
    this.element.classList.add('flickity-resize');
  };